import { cn } from "../../lib/utils"

/**
 * Skeleton — loading placeholder primitive.
 *
 * Institutional Console redesign §6 fix (issue #235 round-2, ui-design-expert
 * review finding B1): spec §6 caps skeleton shimmer at "no skeleton shimmer
 * >1 cycle" and §7 requires `prefers-reduced-motion` to disable it entirely.
 * Tailwind's default `animate-pulse` utility loops the built-in `pulse`
 * keyframe (`{ '50%': { opacity: '.5' } }`) forever, which violates both
 * requirements. This uses the SAME `pulse` keyframe via an arbitrary-value
 * animation (`animate-[pulse_1.2s_ease-in-out_1]`) with an explicit
 * iteration-count of 1 instead of Tailwind's implicit `infinite`, so the
 * shimmer plays exactly once and then settles at the static `bg-muted`
 * color (no lingering half-opacity — the keyframe's `0%`/`100%` implicit
 * opacity is 1, matching the resting state). `motion-reduce:animate-none`
 * drops the animation entirely under `prefers-reduced-motion: reduce`.
 * This is an approved exception to the "do not modify ui-v2 primitives"
 * rule — ratified by the ui-design-expert round-2 review specifically
 * because the defect lives in this shared primitive, not in a caller.
 * API (props, className contract) is unchanged.
 */
function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn(
        "animate-[pulse_1.2s_ease-in-out_1] motion-reduce:animate-none rounded-md bg-muted",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton }
